const invalidEmail = 'Sähköpostiosoite virheellinen';
const emailLabel = 'Sähköposti';
const login = 'Kirjaudu sisään';

const fi: LocaleType = {
  cancellation: {
    noRefund: 'Ei peruutusoikeutta',
    free: 'Ilmainen peruutus',
    arrival: (...args: string[]) =>
      `${args[0]} ${
        parseInt(args[0]) > 1 ? 'päivää' : 'päivä'
      }  ennen saapumista`,
  },
  header: 'this is a header',
  subtitle: (...args: string[]) => `${args[0]} is ${args[1]}`,
  cancel: 'Peru',
  update: 'Päivitä',
  login_button: login,
  signout: 'Kirjaudu ulos',
  menu: 'Menu',
  loading: 'Odota hetkinen',
  read_more: 'Lue lisää',
  camps: {
    allImagesButton: (...args: string[]) => `kaikki kuvat (${args[0]})`,
  },
  auth: {
    successAuth: 'Todennus onnistui. Uudelleenohjaus kotisivulle',
    processing: 'Käsitellään todennusta',
    invalidAuth: 'Virheellinen istunto käyttäjälle.',
  },
  errors: {
    default: 'Pyyntöä ei voi toimittaa.',
    duplicate: 'Tiedot ovat jo järjestelmässä.',
    invalidEmail: invalidEmail,
    requiredEmail: 'Sähköpostiosoite on pakollinen.',
    invalidName: 'Nimi on virheellinen.',
    requiredName: 'Nimi on pakollinen.',
    invalidDate: 'Päivämäärä on virheellinen.',
    requiredDate: 'Päivämäärä on pakollinen.',
    disclaimer: 'Vastuunvapauslauseke on hyväksyttävä jatkaaksesi.',
  },
  cookie: {
    message:
      'Tämä sivusto käyttää evästeitä antaakseen sinulle erinomaisen käyttökokemuksen. Jatkamalla tämän verkkosivuston käyttöä hyväksyt evästeiden käytön kanssamme.',
    policy: 'Evästekäytännöt',
    accept: 'Hyväksy',
  },
  landing_page: {
    header: {
      user: {
        hey: (...args: string[]) => `Hei ${args[0]}, `,
        bookings: 'katso omat varauksesi tästä',
        check_bookings: 'Katso omat varaukset',
        has_reservation: 'Varaus jo olemassa? ',
        customer_service: 'Asiakaspalvelu',
      },
      menus: {
        home: 'Etusivu',
        parks: 'Parkit',
        our_story: 'Tarinamme',
        for_host: 'Isännille',
        the_cities: 'Kaupungeille',
        contact_us: 'Ota yhteyttä',
        login: login,
      },
      all_parks: 'Kaikki matkaparkit',
      buy_tickets: 'Osta lippu',
      buy: 'Osta',
      for_host: 'Isännille',
      demonstration: 'Esittely',
      the_cities: 'Kaupungeille',
      make_reservation: 'Tee varaus',
      the_press: 'Lehdistölle',
    },
    footer: {
      follow: 'Seuraa meitä',
      contact: 'Yhteystiedot',
      quick_links: 'Nopeat linkit',
      traveling: 'Matkustan kanssasi',
      other_links: 'Muut linkit',
      privacy_statement: 'Tietosuojatiedot',
      terms_of_delivery: 'Toimitusehdot',
      see_map: 'Katso kartalla',
      travel: 'Mukana matkassa',
      privacy: 'Tietosuojaehdot',
      media: 'Lehdistölle',
      phone: 'Asiakaspalvelu',
    },
    hero: {
      title: 'Paras parkki pysähtyä!',
      text: 'Avaamme kuusi uutta parkkia kesäksi 2020.',
      view_parks: 'Katso matkaparkkeja',
    },
  },
  parks_list_page: {
    hero: {
      title: 'Lempäälä',
      text: 'Nykyaikainen matkaparkki palveluineen Tampereen vieressä',
    },
  },
  park_info: {
    header: 'Valitse saapumis- ja lähtemispäivä kalenterista',
    amenities: (...args: string[]) =>
      `${args[0]} paikat ja ${args[1]} mukavuudet:`,
    faq: 'Usein kysytyt kysymykset',
    extras: {
      area: 'Alue',
      forWhom: 'Kenelle',
      thingsToDo: 'Näkemistä ja tekemistä',
    },
    intro: 'Tarinamme',
    country: 'Maa',
    region: 'Alue',
    location: 'Sijainti',
    night: 'yö',
    show_more: 'Näytä enemmän',
    show_less: 'Näytä vähemmän',
    suitable_for: 'Paikkoja',
    caravan: 'Asuntovaunu',
    camper_van: 'Camper Van',
    tent: 'Teltta',
    cottages: 'Mökkejä',
    startsFrom: 'Paikkamaksu per yö',
  },
  reservation: {
    noReservation: 'Ei varauksia',
    continue: 'Jatka',
    previous: 'Edellinen',
    loading: 'Odota hetkinen',
    slots: {
      header: 'Montako yötä aiot parkkeerata?',
      arrival: (...args: string[]) => `Saapumispäivä ${args[0]}.`,
      comment: (...args: string[]) =>
        `Seuraava viikonloppu on loppuunmyyty, joten enimmäismäärä öitä per oleskelu voi olla ${args[0]}.`,
      choose: '[FI] Select Slot',
      chooseTitle: 'Varaa paikka',
      unavailable: '[FI] unavailable',
      price: (...args: string[]) => `(${args[0]}€/yö)`,
      addPrice: (...args: string[]) => `(+${args[0]}€/yö)`,
      summary: (...args: string[]) => `Varauksen kokonaishinta on ${args[0]}€.`,
    },
    coupon: {
      validateCoupon: 'Vahvista',
      couponCode: 'Kuponkikoodi',
      couponApplied: 'Kuponki lisätty.',
      couponDiscount: 'Kuponkialennus',
      validationFailed: 'Validointi epäonnistui.',
      validation: {
        couponCodeInvalid: 'Virheellinen kuponkikoodi.',
        couponExpired: 'Kuponki on jo vanhentunut.',
        invalidCamp: 'Kuponki ei käy valitulle leirintäalueelle.',
        usageLimitExceeded: 'Kupongin käyttömäärä on ylittyy.',
        customerNightsLimitExceeded:
          'Kupongin käytettävissä olevat yöt ylittyy.',
        customerRemainingNights: (...args: string[]) =>
          `Kupongilla vielä ${args[0]} yötä jäljellä ennen maksua.`,
      },
    },
    registration: {
      booking: 'Varaaminen',
      of: '/',
      header: 'Täytä yhteystietosi',
      subheader: 'Onko sinulla jo oma BestPark tili?',
      login: 'Kirjaudu sisään tästä',
      loginNote:
        'Kirjaudu sisään tarkistaaksesi varaustiedot. Kirjaudu sisään tästä',
      firstName: 'Etunimi',
      lastName: 'Sukunimi',
      phone: 'Puhelinnumero',
      phoneInfo: '(kansainvälisessä muodossa, esim. +358401234567)',
      phoneLabel: 'Ole hyvä ja anna puhelinnumerosi',
      email: 'Sähköposti',
      street: 'Katuosoite',
      postalCode: 'Postinumero',
      town: 'Kaupunki',
      country: 'Maa',
      license: 'Rekisterinumero',
      membershipCard1: 'SF Caravan',
      membershipCard2: 'C.C.I.',
      membershipNote:
        'Sinun on esitettävä tämä kortti, kun kirjaudut tähän leiriin, ja sen on oltava voimassa koko loman ajan.',
      promos:
        'Lähettäkää minulle BestParkin uutiskirje ja tarjouksia sähköpostiin',
      marketing:
        'Tilaa uutiskirjeemme ja vastaanota uusimmat tarjoukset ja kupongit',
      newsletter:
        'Lähetämme noin kerran kuukaudessa uutiskirjeen, joka sisältää sinulle sopivia tarjouksia.',
      next: 'Seuraava',
      errors: {
        fillRequired: 'Täytä korostetut kentät',
        email: 'Sähköpostiosoite virheellinen',
        name: 'Name is required.',
        licensePlate: 'License plate number is required.',
        phone:
          'Numeron pitää olla kansainvälisessä muodossa, esim. +358401234567',
        membership: 'Jäsennumeron on oltava muotoa 123456-1 tai 1234567-1',
        emailExist: 'Sähköpostiosoite on jo rekisteröity.',
        fieldRequired: 'Pakollinen kenttä',
        fieldTooLong: 'Kentän arvo on liian pitkä',
      },
      clickHereToReserve: 'Aloita varauksesi tästä',
    },
    parking: {
      header: 'Parking',
      subheader: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
      noSlots: 'No parking slots available',
    },
    payment: {
      header: 'Varauksen yhteenveto',
      subheader: 'Viimeistele varaus valitsemalla maksutapa.',
      night: (...args: string[]) =>
        `${args[0]} ${
          parseInt(args[0]) > 1 ? 'vuorokautta' : 'vuorokausi'
        } parkissa`,
      total: 'Yhteensä',
      cardPay: 'Maksa pankki- tai luottokortilla',
      mobilePay: 'Maksa mobiilimaksulla',
      collectorBankPay: 'Maksa laskulla tai erissä',
      stripePay: 'Maksut välittää Stripe',
      invoicePayment: 'Maksa laskulla',
      invoiceNote: (...args: string[]) =>
        `laskutuslisä ${args[0]} ${Number(args[0]) > 1 ? 'euroa' : 'euro'}`,
      surcharge: 'Lisämaksu',
      onlineBankPay: 'Maksa verkkopankissa',
      coupon: 'Onko sinulla kampanjakoodi?',
      continueWithoutCoupon: 'Jatka ilman kampanjakoodia.',
      terms1: 'Olen lukenut',
      terms2: 'tilaus- ja toimitusehdot',
      terms3: 'Perustamme helppokäyttöisen asiakastilin ostoksillesi',
      pay: (...args: string[]) => `Maksa ${args[0]} nyt`,
      processingPayment: 'Käsitellään varausmaksua',
      paymentProcessed:
        'Maksusi on käsitelty ja antamaasi sähköpostiosoitteeseen on lähetetty varausvahvistusviesti. Mikäli varausvahvistusta ei ole saapunut 15 minuutin kuluessa, tarkistathan ettei viesti ole mennyt roskapostikansioon.',
      paymentError:
        'Something went wrong! Our team will look into this. You may contact support.',
      paymentCancelled: 'Maksu peruutettu, yritä uudelleen.',
      priceDetails: 'Hintatiedot',
      additionalGuests: 'Lisähenkilöt',
      discount: 'Any discount codes can be entered in the next screen.',
      goToPayment: 'Siirry maksuun',
      to: 'että',
    },
    card: {
      goToReservation: 'Mene varaukseeni',
      days: (...args: string[]) =>
        `${args[0]} ${parseInt(args[0]) > 1 ? 'vuorokautta' : 'vuorokausi'}`,
    },
    profile: {
      header: 'Varaukseni',
    },
    guestInformation: {
      passenger: 'Matkustaja',
      passengers: 'Matkustajat',
      header: 'Matkustajailmoitus',
      firstName: 'Etunimi',
      lastName: 'Sukunimi',
      address: 'Osoite',
      dateOfBirth: 'Syntymäaika',
      nationality: 'Kansalaisuus',
      passportNumber: 'Passin/henkilökortin numero',
      dateOfArrival: 'Saapumispäivä',
      countryOfEntry: 'Maa, josta matkustaja saapuu Suomeen',
      addChildButton: 'Lisää perheenjäsen',
      addPassenger: 'Lisää toinen matkustaja',
      passengerInformation: 'Matkustajan henkilötiedot',
      childSpouseInfo: 'Perheenjäsenen henkilötiedot',
      passportInfo: 'Pohjoismaiden kansalaiset eivät täytä',
      companionHeader:
        'Matkustajan mukana olevan puolison ja alaikäisten lasten henkilötiedot',
      subHeader:
        'Väärien henkilötietojen antamisesta on säädetty rangaistus rikoslaissa.',
      delete: 'poista',
      campPassengerHeader: 'Anna matkustajatiedot',
      campPassengerSubHeader:
        'Meillä on lakisääteinen velvollisuus pyytää näitä tietoja, väärien henkilötietojen antamisesta seuraa rikoslain mukainen rangaistus.',
      next: 'Seuraava',
      completeData:
        'Jokaiselta matkustajalta vaaditaan täydelliset henkilötiedot',
    },
    ancillary: {
      header: 'Lisäpalvelut',
      skip: 'Siirry seuraavaan',
      subheader1: 'Viivy matkalla, vaikka Parkissa',
      subheader2:
        'Sähköpotkulautoja ja pyöriä vuokrattavana kaikissa Parkeissa',
      subheader3:
        'Paikkoja saatavava rajoitettu määrä, joten varaa omasi ajoissa!',
      soldOut: 'Valitettavasti loppuunmyyty valitseminasi päivinä',
      soldOutDay: (...args: string[]) =>
        `Kaikki ${args[0]} on varattu tälle päivälle`,
      price: (...args: string[]) => `${args[0]}€ vuorokausi`,
      reservation: (...args: string[]) =>
        `Kuinka monta ${args[0]} ja mille päiville tarvitset niitä?`,
      max: (...args: string[]) =>
        `Vain ${args[0]} vapaana valitsemallesi päivälle`,
      total: 'Yhteensä:',
      totalService: (...args: string[]) =>
        `${args[0]} ${args[1]} on ${args[2]} ${
          parseInt(args[2]) > 1 ? 'Päivät' : 'Päivä'
        }`,
      firstDayNote:
        'Varauksesi alkaa klo 13 ja on voimassa seuraavaan päivään klo 12 asti.',
      dayNote: 'Reservation starts at 12:00 and ends 12:00 next day',
      lastDayNote: 'Reservation starts at 12:00 and ends 12:00 next day',
    },
    details: {
      checkIn: login,
      checkOut: 'Kirjaudu ulos',
      startBooking: 'Aloita varaaminen',
      perNight: 'per yö',
      info:
        'Sisäänkirjautumisaika  kello 13.00 joka päivä ja uloskirjautumisaika on klo 12.00 mennessä',
      addOns: {
        earlyCheckIn: {
          info: ' Myöhäinen sisäänkirjautuminen klo 13 asti',
          button: (...args: string[]) => `Lisää kohteelle ${args[0]}€`,
        },
        lateCheckOut: {
          info: 'Myöhäinen uloskirjautuminen klo 15:00',
          button: (...args: string[]) => `Lisää kohteelle ${args[0]}€`,
        },
      },
      parking: {
        title: 'Parkkisi',
        slot: (...args: string[]) =>
          `Sinulle on varattu matkaparkkipaikka numero ${args[0]}.`,
      },
      map: {
        button: 'Navigoi Parkkiin',
      },
      general: {
        title: 'Portti avautuu',
        text:
          'Kun saavut Parkkiin, voit avata portin tällä henkilökohtaisella koodilla:',
        linkInfo: (...args: string[]) => `Näytä tiedot ${args[0]}`,
        linkModify: 'Haluatko muokata tai peruuttaa tämän varauksen?',
        linkDownload: 'Lataa kuitti',
        add: 'Lisää',
      },
      services: {
        title: (...args: string[]) => `Sinun ${args[0]}`,
        text: (...args: string[]) =>
          `Tähän tulee ohjeet, mistä voit noutaa varaamasi ${args[0]}.`,
      },
      cancelReservation: 'Peruuta varaus',
      cancelledReservation: 'Peruttu varaus',
    },
    confirmation: {
      confirmed: 'Varauksesi on vahvistettu',
      pending: 'Varaus on tällä hetkellä odottamassa.',
      confirmed_message: (...args: string[]) =>
        `Kiitos varauksestasi, nähdään ${args[0]}`,
    },
    errors: {
      cancel: 'Voit peruuttaa varauksen 7 päivää ennen saapumistasi',
    },
    success: {
      cancel: 'Varaus on peruttu',
    },
    receipt: {
      invoice: (...args: string[]) => `Kuitti #${args[0]}`,
      header: (...args: string[]) =>
        `Kiitos varauksesta ${args[0]}, se on maksettu kokonaisuudessaan ${args[1]}€`,
      details: {
        paymentDate: 'Maksupäivä',
        contactEmail: 'Sähköpostiyhteys',
        chargedTo: 'Veloitetaan',
        forReservation: 'Varaukselle',
      },
      breakdown: {
        subtotal: 'Välisumma',
        grandTotal: 'Yhteensä',
        vat: (...args: string[]) => `Alv. (${args[0] ?? 10}%)`,
      },
    },
    widget: {
      additionalGuests: 'Lisähenkilöt',
      from: 'Alkaen',
      priceBreakdown: 'Price breakdown',
      night: 'yö',
      nights: (...args: string[]) =>
        `${args[0]} ${parseInt(args[0]) > 1 ? 'yötä' : 'yöltä'}`,
      total: 'Yhteensä',
      inclusions: 'Tähän yöpymishintaan sisältyy:',
    },
    sendBookingRequest: {
      submit: 'Lähetä varauspyyntö',
      success: 'Varauspyyntö lähetetty onnistuneesti.',
      error: 'Varauspyynnön lähettäminen epäonnistui.',
      disclaimer:
        'Ymmärrän, että tämä ei ole vielä kumpaakaan osapuolta sitova varaus. Tämän varauspyynnön lähetyksen jälkeen, leirintäalue ottaa yhteyttä mahdollisen ajoneuvopaikan löytymiseksi.',
    },
  },
  promotions: {
    general: {
      read_more: 'Lue lisää',
    },
    hotline: {
      title: 'Puhelin­päivystys 24/7',
      text: 'Asiakaspalvelu on aina tavoitettavissa',
      footer: 'Puhelun hinta 0300-numeroon 8,35 snt/puh + 16,69 snt/min ',
    },
    infos: {
      title: 'Vaikuta!',
      text: 'Vinkkaa parhaat paikat ja osallistu lahjakorttien arvontaan.',
      buttonText: 'Kyselyyn',
    },
  },
  login: {
    header: 'Kirjaudu tilillesi',
    subheader: 'Ei vielä tiliä? ',
    registrationLink: 'Rekisteröidy tästä',
    forgetPasswordLink: 'Unohditko salasanan?',
    email: emailLabel,
    password: 'Salasana',
    continue: 'Jatka',
    authContent:
      'Lisää todennuskoodi, joka on lähetetty tekstiviestissä numeroon ',
    editNumber: 'Muokkaa numeroa',
    verify: 'Vahvistuskoodi',
    sms: 'lähetetään tekstiviestillä',
    errors: {
      fillRequired: 'Täytä korostetut kentät',
      email: invalidEmail,
      sessionInvalidated: 'Istunto vanhentunut, kirjaudu sisään uudelleen',
      invalidCode: 'Kelpaamaton koodi',
    },
    verifyRequired: 'Verification code is required',
    resendCode: 'Lähetä koodi uudestaan',
    resending: 'Lähettää uudestaan...',
    next: 'Next',
  },
  mail: {
    header: 'Tarkista puhelimesi',
    open: 'Avaa Mail-App',
    content: (...args: string[]) =>
      `Lähetimme kirjautumislinkin osoitteeseen ${args[0]}, josta pääset kirjautumaan sisään.`,
  },
  registration: {
    header: 'Rekisteröi tili',
    subheader: 'Onko sinulla jo oma BestPark tili? ',
    registerButton: 'Rekisteröi',
    success: {
      header: 'Rekisteröitymisesi onnistui.',
      content: 'Voit nyt kirjautua tilillesi.',
    },
  },
  profileEdit: {
    header: 'Muokkaa käyttäjätiliä',
    subheader: 'Päivitä käyttäjätilisi tiedot',
    editButton: 'Muokkaa käyttäjätietoja',
    success: {
      header: 'Asiakastilin tiedot päivitetty',
      content: 'Asiakastilini',
    },
  },
  calendar: {
    general: {
      start_reservation: 'Aloita varaus',
      select_check_in: 'Valitse sisäänkirjautumispäivä',
      select_check_out:
        'Valitse uloskirjautumispäivä ja klikkaa aloita varaus.',
      summary: (...args: string[]) =>
        `Varaus alkaen ${args[0]} jatkuen ${args[1]} asti.\nSisäänkirjautuminen alkaen klo 13.00, uloskirjautuminen viimeistään klo 12.00. Hinta yhteensä: ${args[2]}€.`,
    },
    months: {
      january: 'tammikuu',
      february: 'helmikuu',
      march: 'maaliskuu',
      april: 'huhtikuu',
      may: 'toukokuu',
      june: 'kesäkuu',
      july: 'heinäkuu',
      august: 'elokuu',
      september: 'syyskuu',
      october: 'lokakuu',
      november: 'marraskuu',
      december: 'joulukuu',
    },
    in_months: {
      january: 'tammikuussa',
      february: 'helmikuussa',
      march: 'maaliskuussa',
      april: 'huhtikuussa',
      may: 'toukokuussa',
      june: 'kesäkuussa',
      july: 'heinäkuussa',
      august: 'elokuussa',
      september: 'syyskuussa',
      october: 'lokakuussa',
      november: 'marraskuussa',
      december: 'joulukuussa',
    },
    weeks: {
      monday: 'Ma',
      tuesday: 'Ti',
      wednesday: 'Ke',
      thursday: 'To',
      friday: 'Pe',
      saturday: 'La',
      sunday: 'Su',
    },
  },
  parks: {
    from: 'Alkaen',
    check_advance: 'Tutustu ennakkoon',
    promotion: (...args: string[]) =>
      `Meillä on ${args[0]} nykyaikaista matkaparkkia kesäksi ${args[1]}`,
    per_night: 'vuorokausi',
    listTitle: (...args: string[]) => `Kesän ${args[0]} parkit:`,
  },
  newsletter: {
    title: 'Tilaa uutiskirje',
    subscribe: 'Tilaa',
    subscribeMsg:
      'Älä aja parkkisi ohi! Tilaa uutiskirje ja kuulet ensimmäisten joukossa tuoreimmat BestPark-uutiset.',
    notifications: {
      subscribeSuccess: 'Kiitos mielenkiinnosta, kuulet meistä pian!',
      subscribeError: 'Virhe pyyntösi käsittelyssä. Ole hyvä, yritä uudelleen.',
    },
  },
  mediaPage: {
    visualisation: 'Visualisointikuvat',
    stock: 'Kuvituskuvat',
    parkImages: 'Alueen esittely',
  },
  contactUs: {
    billingHeader: 'Laskutustiedot',
    businessId: 'Y-tunnus',
    paymentTerm: 'Maksuehto',
    paymentTermValue: (term: string) => `${term}pv`,
    invoiceAddress: 'Verkkolaskuosoite',
    brokerAddress: 'Välittäjän osoite',
    send: 'Lähetä',
  },
  articles: {
    title: 'Karavaanielämää',
  },
  formLabels: {
    message: 'Viestisi',
    name: 'Nimi',
    email: emailLabel,
    phoneNumber: 'Puhelinnumero',
    place: 'Paikkakunta',
    authCode: 'Todennuskoodi',
  },
  amenities: {
    title: 'Mukavuudet',
  },
  other: {
    title: 'Other Info',
    cancellationPolicy: 'Peruutusehdot',
    notes: 'Info',
  },
};

export default fi;
